import { handleActions } from 'redux-actions';
import {
  sectionIdListStatementContentOcrLoading,
  sectionIdListStatementContentOcrLoaded,
  sectionIdListStatementContentOcrError,
  clearStatementPageStoreAction,
} from 'store/actions/statement-content-actions';
import { SectionIdListOcr } from 'models/api/section-id-list-ocr-model';

export default handleActions(
  {
    [sectionIdListStatementContentOcrLoading]: (sectionIdListOcr) => {
      return sectionIdListOcr.setLoading();
    },
    [sectionIdListStatementContentOcrLoaded]: (
      sectionIdListOcr,
      { payload },
    ) => {
      return sectionIdListOcr.setLoaded(payload);
    },
    [sectionIdListStatementContentOcrError]: (
      sectionIdListOcr,
      { payload },
    ) => {
      return sectionIdListOcr.setError(payload);
    },
    [clearStatementPageStoreAction]: () => {
      return new SectionIdListOcr();
    },
  },
  new SectionIdListOcr(),
);
